import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7eb296bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "profile_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "profile_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "profile_title_text" }, "メールアドレスの編集")
], -1))
const _hoisted_3 = { class: "profile_input" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_label" }, "メールアドレス"),
  /*#__PURE__*/_createElementVNode("span", { class: "input_title_required" }, "必須")
], -1))
const _hoisted_5 = { class: "profile_input_layout_column_1" }
const _hoisted_6 = { class: "profile_input_layout_column_1_item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text_list" }, "勤務先メールアドレスのご登録はお控えください", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text_list" }, "求人案内などの連絡先として使用します。常時確認できるメールアドレスをご登録ください", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "profile_text_list" }, "メール受信制限をされている方は「@massmedian.co.jp」からのメール受信を許可してください", -1))
const _hoisted_10 = { class: "profile_button" }
const _hoisted_11 = { class: "profile_button_prev" }
const _hoisted_12 = { class: "profile_button_next" }

import BaseTextForm from '@/components/BaseTextForm.vue';
import BaseButton from '@/components/BaseButton.vue';
import ErrorMessage from '@/components/ErrorMessage.vue';
import store from '@/store';
import { useRouter, useRoute } from 'vue-router';
import { useField, useForm } from 'vee-validate';
import { validationRuleHelper } from '@/utils/validationRule';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailEditView',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { meta } = useForm();

const {
  value: email,
  errors: emailErrors,
  meta: emailMeta,
} = useField<string>('email', validationRuleHelper({ required: true, max: 50, email: true }), {
  initialValue: store.getters['userRegistration/mailAddress'],
  bails: false,
  label: 'メールアドレス',
});

const transitionPage = () => {
  store.commit('userRegistration/setMailAddress', email.value);
  if (route.query.ref === 'e') {
    router.push({ name: 'e24', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e24' });
  }
};

const transitionPreviousPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e20', query: { ref: 'e' } });
  } else {
    router.push({ name: 'n20' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(BaseTextForm, {
            maxlength: 50,
            modelValue: _unref(email),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
            isError: !_unref(emailMeta).valid
          }, null, 8, ["modelValue", "isError"])
        ])
      ])
    ]),
    _createVNode(ErrorMessage, { errors: _unref(emailErrors) }, null, 8, ["errors"]),
    _hoisted_7,
    _hoisted_8,
    _hoisted_9,
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createVNode(BaseButton, {
          theme: "tertiary",
          type: "button",
          onClick: transitionPreviousPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("戻る")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(BaseButton, {
          theme: "primary",
          type: "button",
          onClick: transitionPage,
          disabled: !_unref(meta).valid
        }, {
          default: _withCtx(() => [
            _createTextVNode("確認する")
          ]),
          _: 1
        }, 8, ["disabled"])
      ])
    ])
  ]))
}
}

})